export default {
  toasts: {
    load_error: 'Could not load the invoices.',
    action_error: 'The action failed — please try again.',
    finalized: 'Invoice finalized.',
    marked_paid: 'Invoice marked as paid.',
  },
  filters: {
    status: 'Filter by status',
  },
  volume_discount_badge: 'Volume discount applied ({{licenses}} licences, {{percent}}%)',
  columns: {
    description: 'Invoice',
    status: 'Status',
    total: 'Total',
    paid_at: 'Paid at',
  },
  statuses: {
    pending: 'Pending',
    processing: 'Processing',
    paid: 'Paid',
    failed: 'Failed',
    refunded: 'Refunded',
    partially_refunded: 'Partially refunded',
  },
  companies: {
    partner_level: 'Partner-level adjustments',
    columns: {
      company: 'Restaurant',
      buckets: 'Positions',
      amount: 'Amount',
    },
  },
  buckets: {
    license_fees: 'Licence fees',
    service_fees: 'Service fees',
    processing_fees: 'Processing fees',
    delivery_fees: 'Delivery fees',
    gift_card_fees: 'Gift card fees',
    adjustments: 'Adjustments',
  },
  entries: {
    count: '{{count}} entries',
    columns: {
      description: 'Entry',
      occurred_at: 'Date',
      amount: 'Amount',
    },
  },
  incl_tax: 'incl. {{amount}} VAT',
  actions: {
    open_invoice_pdf: 'Download invoice (PDF)',
    open_hosted: 'Open invoice on Stripe',
    export_csv: 'Export CSV',
    finalize: 'Finalize on Stripe',
    mark_paid: 'Mark as paid',
  },
  finalize: {
    title: 'Finalize this invoice on Stripe?',
    description:
      'Finalizing starts collection: with a saved payment method the charge runs automatically, otherwise the partner receives the hosted invoice.',
    confirm: 'Finalize',
  },
  mark_paid: {
    pushed_note:
      'This invoice is already on Stripe — the draft will be deleted (or a finalized invoice marked as paid out of band) so Stripe stops collecting.',
    title: 'Mark this invoice as paid?',
    description:
      'Records a manual (offline) payment of {{amount}}. Use this for bank transfers collected outside Stripe.',
    confirm: 'Mark as paid',
  },
  settlement_badge: {
    paid: 'Revenue share paid out: {{amount}}',
    other: 'Revenue share payout {{amount}} · {{status}}',
  },
  settlements: {
    title: 'Revenue share payouts',
    retry: 'Retry',
    toasts: {
      load_error: 'Could not load the payouts.',
      retry_error: 'The retry failed — please try again.',
      retry_paid: 'Revenue share paid out.',
      retry_attempted: 'Retry ran — the payout is not through yet, check its status.',
    },
    columns: {
      period: 'Period',
      amount: 'Amount',
      status: 'Status',
      transfer: 'Transfer',
      paid_at: 'Paid at',
      payout: 'Payout',
    },
    payout: {
      direct: '{{amount}}, no conversion',
      direct_tooltip:
        'Owed {{owed}}, converted at 1 {{payout_currency}} = {{ledger_rate}} {{billing_currency}} and sent as is: no Stripe conversion, no fee.',
      converted: 'Sent {{sent}} → arrived {{arrived}}',
      expected: 'Sent {{sent}} → expected {{arrived}}',
      fee: 'Stripe conversion fee {{amount}}',
      net: 'net {{amount}}',
      pending_details: 'Fee and net appear once Stripe settles the transfer.',
      tooltip:
        'Owed {{owed}}. Converted at 1 {{payout_currency}} = {{ledger_rate}} {{billing_currency}}, sent from the platform balance in {{source_currency}}, and converted by Stripe at 1 {{source_currency}} = {{stripe_rate}} {{payout_currency}}. Stripe deducts {{fee_rate}}% on arrival.',
    },
    statuses: {
      pending: 'Pending',
      held: 'Held',
      processing: 'Processing',
      paid: 'Paid out',
      failed: 'Failed',
      reversed: 'Reversed',
    },
    hold_reasons: {
      kyc_incomplete: 'The partner has not completed the payout account verification yet.',
      transfers_inactive: 'The payout account cannot receive transfers yet.',
      insufficient_platform_balance: 'The platform balance cannot cover this payout right now.',
      manual_hold: 'Held manually.',
      missing_fx_rate: 'No exchange rate is stored for the payout currency yet. It is retried automatically.',
      unsupported_payout_currency:
        'Stripe cannot pay this out into the payout account currency from the platform balance.',
      amount_too_small: "The amount owed is below Stripe's minimum transfer for this currency.",
    },
  },
};
